export const APP_LOCAL_STORAGE_VERSION = 'REACT_APP_VERSION';
export const APP_LOCAL_STORAGE_X_STATE_INSPECT_ENABLED = 'APP_LOCAL_STORAGE_X_STATE_INSPECT_ENABLED';
export const APP_LOCAL_STORAGE_X_STATE_SNAPSHOTS_ENABLED = 'APP_LOCAL_STORAGE_X_STATE_SNAPSHOTS_ENABLED';
export const APP_LOCAL_STORAGE_CONTENT_SEEN_PREFIX = 'content-seen.';
export const APP_LOCAL_STORAGE_AUTHENTICATION_NAMESPACE = 'amica-web-authentication';
export const APP_LOCAL_STORAGE_OKTA_TOKEN_STORAGE = 'okta-token-storage';
